export default "__VITE_ASSET__DBTpaxjJ__"